import { render, staticRenderFns } from "./TextEditorMenu.vue?vue&type=template&id=60be752a"
import script from "./TextEditorMenu.vue?vue&type=script&lang=js"
export * from "./TextEditorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports